import {Fragment, useContext, useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {Trans} from '@lingui/macro'
import {randStr} from '../../utils'
import {
  Badge,
  Box,
  Collapse,
  Divider,
  Drawer,
  FormControlLabel,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  styled,
  Switch,
  Toolbar,
  Typography,
  useTheme
} from '@mui/material'
import OrganizationIcon from '../OrganizationIcon'
import {useRoutes} from '../../store/routesContext'
// import { ThemeContext } from '../../App'
// import { MaterialUISwitch } from '../forms/UserForm'
// import { Controller, useForm } from 'react-hook-form'
import {useActionLogs} from '../../store/actionLogsContext'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import SvgCustomIcon from "../icons/SvgCustomIcon";
import {ThemeContext} from "../../App";

const StyledBadge = styled(Badge)(() => ({
  '& .MuiBadge-badge': {
    right: -10
    // , top     : 15
    // , border  : `2px solid ${theme.palette.background.paper}`
    // , padding: '0 4px'
  }
}))


export default function DesktopNav({ position, subPanelElements }) {
  const routes = useRoutes()
  const theme = useTheme()
  const drawerWidth = theme.mixins.drawerWidth
  const location = useLocation()
  const { state = {}, state: { init } = {} } = location
  const navigate = useNavigate()
  const [switches, setSwitches] = useState(() => subPanelElements?.map(() => false))
  // const { mode, toggleTheme } = useContext(ThemeContext)
  // const { control } = useForm()
  const { count: newLogsCount } = useActionLogs()
  const { mode } = useContext(ThemeContext)

  const handleListItemClick = (_, route) => {
    if (route === '/history') { // History is a component of home, not a page
      navigate('/home', { state: { ...state, isHistoryOpen: route === '/history' } })
    } else {
      navigate(route, { state: { ...state, isHistoryOpen: false } })
    }
  }

  const iconSizeStyle = {
    height: 20,
    width: 20
  }


  const mainPanelElementsProps = [
    {
      label: <Trans>Data visualization</Trans>
      , icon: <SvgCustomIcon name={'home'} size={20} />
      , route: '/home'
      , subPanelsNumber: 6
      , access: [0, 1, 2]
    }
    , {
      label: <Trans>Admin</Trans>
      , icon: <SvgCustomIcon name={'shieldPerson'} size={20} />
      , route: '/admin'
      , subPanelsNumber: 3
      , access: [1, 2]
    }
    , {
      label: <Trans>Data analysis</Trans>
      , icon: <SvgCustomIcon name={'barChart3'} size={20} />
      , route: '/statistics'
      , subPanelsNumber: 2
      , access: [0, 1, 2]
    }
    , {
      label: <Trans>History</Trans>
      , icon: <SvgCustomIcon name={'history'} size={20} />
      , route: '/history'
      , subPanelsNumber: 0
      , access: [1]
      , badge: newLogsCount
    }
    , {
      label: <Trans>Help</Trans>
      , icon: <SvgCustomIcon name={'help'} size={20} />
      , route: '/help'
      , subPanelsNumber: 0
      , access: [0, 1, 2]
    }
    , {
      label: <Trans>Data merging and validation</Trans>
      , icon: <SvgCustomIcon  name={'merge'} size={20} />
      , subPanelsNumber: 0
      , route: '/tools'
      , access: [1]
    }
  ]

  const mainPanelElements = routes.map(route =>
    mainPanelElementsProps.find(element => element.route === route) || { route }
  )

  const getUsername = () => {
    const fullName = init?.user?.name + ' ' + init?.user?.surname
    if(fullName){
      if(fullName.length > 25){
        return fullName.substring(0,20) + '...'
      } else {
        return fullName
      } 
    } else {
      return init?.user?.surname
    }
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth
          , flexShrink: 0
          , '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box' }
        }}
      >
        <Toolbar sx={{ height: theme.mixins.toolbar.minHeight, justifyContent: 'center', alignItems: 'center', display: 'flex',paddingLeft: '14px !important' }} >
          
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start' }}>
          <Box sx={{flex:0.4,display:'flex'}}>
          <OrganizationIcon organization={init.user.organization} userType={init.user.type} style={{ color: '#4a4a4a', fontSize: 24 }} />
          </Box>
          <Box sx={{display: 'flex',flexDirection: 'column', marginLeft: 1}}>
            <Typography sx={{ fontSize: {
              xs: '10px',
              sm: '11px',
              md: '12px',
              lg: '13px',
              xl: '14px'
            }, fontWeight: 700,marginLeft:1 }} >{getUsername()}</Typography>
            <Typography sx={{ fontSize: {
              xs: '8px',
              sm: '9px',
              md: '10px',
              lg: '11px',
              xl: '12px'
            },marginLeft:1 }}>{init.user.department}</Typography>
            </Box>
          </Box>
        </Toolbar>
        <Box sx={{ overflow: 'auto' }}>
          {Object.keys(init).length &&
            <>
              {/* <Typography>{organizations.find(o => o.value === init.user.organization).label}</Typography> */}
              <Divider />
              <List>
                {mainPanelElements
                  .filter(elem => elem.access?.includes(init.user.type))
                  .map((elem, index) => (
                    <Fragment key={`${elem.label}-${randStr()}`}>
                      <ListItemButton // TODO
                        selected={index === routes.map(route => route.path).indexOf('/history') || index === position}
                        onClick={() => handleListItemClick(null, elem.route)}
                        sx={{ width: '100%'}}
                      >
                        {elem.route === '/history'
                          ?
                            <Box
                                display="flex"
                                flexDirection="row"
                                alignItems="center"
                                width="100%"
                            >
                              <Box display="flex" alignItems="center">
                                {elem.icon}
                                <Typography fontSize={15} marginLeft={4}>
                                  {elem.label}
                                </Typography>
                              </Box>

                              {elem.badge > 0 && (
                                  <Box
                                      sx={{
                                        minWidth: 22,
                                        height: 22,
                                        borderRadius: '50%',
                                        background: theme.palette.newColors.pinkGradient,
                                        color: 'white',
                                        fontSize: 13,
                                        fontWeight: 600,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        ml: 2,
                                        px: 1,
                                      }}
                                  >
                                    {elem.badge}
                                  </Box>
                              )}
                            </Box>

                            : <Box display='flex' flexDirection='row' alignItems='center'>
                            {elem.icon}
                            <Typography fontSize={15} flex={2} marginLeft={4}>{elem.label}</Typography>
                            {elem.subPanelsNumber > 0  ?
                              position === index && !location.state.isHistoryOpen ? <KeyboardArrowUpIcon sx={{right:2,position:'absolute'}}/>  : <KeyboardArrowDownIcon sx={{right:2,position:'absolute'}}/>
                              : <></>
                            }
                          </Box>
                        }

                        {/**
                        <ListItemText primary={elem.label} />
                        */}

                      </ListItemButton>
                      <Collapse
                        sx={{boxShadow: 'none',borderLeft: '0.5px solid lightgrey'}}
                        in={position === index && !location.state?.isHistoryOpen} // Valid only if History has no subElems
                        timeout="auto"
                        unmountOnExit
                      >
                        {!!subPanelElements.length && <>
                          <List>
                            {subPanelElements
                              .filter(elem => elem.access.includes(init.user.type))
                              .filter(elem => !elem.baseOrgAccess ||
                                init.user.type === 1 ||
                                elem.baseOrgAccess.includes(init.user.basic_organization))
                              .map((elem, index) => {
                            
                                if (elem.type === 'switch') {
                                  return (
                                    <Fragment key={index}>

                                      <ListItem key={elem.label} sx={{ pl: 4 }}>
                                        <FormControlLabel
                                          sx={{
                                            '& .MuiFormControlLabel-label': {
                                              fontSize: '14px',
                                            },
                                          }}
                                          checked={switches[index]}
                                          control={<Switch />}
                                          label={elem.label}
                                          onChange={e => {
                                            setSwitches(old => old.map((o, i) => i === index ? e.target.checked : o))
                                            elem.action(e.target.checked)
                                          }}
                                        />
                                      </ListItem>
                                    </Fragment>
                                  )
                                }
                                if (elem.type === 'button') {
                                  return (
                                    <Fragment key={index}>
                                      <ListItem disablePadding key={`${elem.label}-${randStr()}`}>
                                        <ListItemButton onClick={elem.action} sx={{ pl: 4 }}>
                                          <ListItemIcon>
                                            {elem.icon}
                                          </ListItemIcon>
                                          <Typography sx={{fontSize: 14,marginLeft:-1 }}>{elem.label}</Typography>
                                          {/*<ListItemText primary={elem.label} />*/}
                                        </ListItemButton>
                                      </ListItem>
                                    </Fragment>

                                  )
                                }
                                return ''
                              })
                            }
                          </List>
                          <Divider />
                        </>}
                      </Collapse>
                    </Fragment>
                  ))}
              </List>
              <Divider />
            </>}
        </Box>
      </Drawer>
    </Box>
  )
}
